import React, { useState } from 'react'
import InputFields from '../components/InputFields';
import { useNavigate } from "react-router-dom"
import { useRegister } from '../hooks/hooks'
import { showErrorToast, showSuccessToast } from '../components/common';

import './../i18n'; // Import the i18n configuration
import { useTranslation } from 'react-i18next';
import SelectPhoneNew from '../modal/SelectPhoneNew';

const Register = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [inputValue, setInputValue] = useState({ firstName: '', lastName: '', email: '', phone: '', password: '' });
    const [Error, setError] = useState({ firstName: '', lastName: '', email: '', phone: '', password: ''});
    const [isLoading, setIsLoading] = useState(false);
    const [acceptedTerms, setAcceptedTerms] = useState(false);
    const [showTerms, setShowTerms] = useState(false);
    const [showPrivacy, setShowPrivacy] = useState(false);
     const [inputMobileData, setInputMobileData] = useState({
            country_code: '',
            phone_number: '',
    });

    const { mutate: registerUser } = useRegister();

    // Function to get current date in DD/MM/YYYY format
    const getCurrentDate = () => {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const year = today.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputValue({
            ...inputValue,
            [name]: value.toString(),
        });
        setError({ ...Error, [name]: '' });
    };

    const registerUserHandler = (inputValue) => {
        // Prepare payload according to API requirements
        const payload = {
            firstName: inputValue.firstName,
            lastName: inputValue.lastName,
            name: `${inputValue.firstName} ${inputValue.lastName}`,
            email: inputValue.email,
            phone: inputValue.phone,
            // businessEmail: inputValue.businessEmail,
            password: inputValue.password,
            termsAccepted: acceptedTerms
        };

        registerUser(payload, {
            onSuccess: (res) => {
                if (res.status === 200 || res.status === 201) {
                    showSuccessToast( res?.data?.message ||"Please verify your email before logging in.");
                    navigate('/login');
                    return;
                }
                setIsLoading(false);
            },
            onError: (res) => {
                setIsLoading(false);
                if (res?.response?.status === 400) {
                    showErrorToast(res?.response?.data?.message || "Registration failed. Please check your details.");
                } else {
                    showErrorToast("Something went wrong! Please try again.");
                }
            }
        });
    };

    const onSubmit = () => {
        // Validation
        if (inputValue.firstName.toString().trim() === "") {
            setError({ ...Error, firstName: 'Please enter first name' });
            return;
        }

        if (inputValue.lastName.toString().trim() === "") {
            setError({ ...Error, lastName: 'Please enter last name' });
            return;
        }

        if (inputValue.email.toString().trim() === "") {
            setError({ ...Error, email: 'Please enter email' });
            return;
        }

        // if (inputValue.businessEmail.toString().trim() === "") {
        //     setError({ ...Error, businessEmail: 'Please enter business email' });
        //     return;
        // }

        const emailRegex = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/;
        if (!emailRegex.test(inputValue.email)) {
            setError({ ...Error, email: 'Invalid Email' });
            return;
        }

        // if (!emailRegex.test(inputValue.businessEmail)) {
        //     setError({ ...Error, businessEmail: 'Invalid Business Email' });
        //     return;
        // }

        if (inputValue.phone.toString().trim() === "") {
            setError({ ...Error, phone: 'Please enter phone number' });
            return;
        }

        const phoneRegex = /^(\+91|91)?[6-9]\d{9}$/;
        const cleanPhone = inputValue.phone.replace(/\s+/g, '').replace(/[^\d+]/g, '');
        
        if (!phoneRegex.test(cleanPhone)) {
            setError({ ...Error, phone: 'Please enter a valid phone number (10 digits starting with 6-9)' });
            return;
        }

        if (inputValue.password.toString().trim() === "") {
            setError({ ...Error, password: 'Please enter password' });
            return;
        }

        if (inputValue.password.length < 6) {
            setError({ ...Error, password: 'Password must be at least 6 characters' });
            return;
        }

        if (!acceptedTerms) {
            showErrorToast("Please accept the Terms & Conditions and Privacy Policy to continue");
            return;
        }

        setIsLoading(true);
        registerUserHandler(inputValue);
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-900 via-primary to-secondary relative overflow-hidden">
            {/* Enhanced Animated Background Elements */}
            <div className="absolute inset-0">
                {/* Additional Smaller Orbs */}
                <div className="absolute top-1/4 left-1/3 w-32 h-32 bg-primary/50 rounded-full mix-blend-multiply filter blur-lg opacity-60 animate-pulse"></div>
                <div className="absolute bottom-1/4 right-1/3 w-24 h-24 bg-secondary/50 rounded-full mix-blend-multiply filter blur-lg opacity-60 animate-pulse animation-delay-1000"></div>
                <div className="absolute top-3/4 left-1/4 w-20 h-20 bg-green-400/50 rounded-full mix-blend-multiply filter blur-lg opacity-60 animate-pulse animation-delay-3000"></div>
                
                {/* Floating Particles */}
                <div className="absolute top-1/4 right-1/4 w-2 h-2 bg-white/30 rounded-full animate-bounce"></div>
                <div className="absolute top-1/3 left-1/5 w-1 h-1 bg-white/40 rounded-full animate-bounce animation-delay-500"></div>
                <div className="absolute bottom-1/3 right-1/5 w-1.5 h-1.5 bg-white/30 rounded-full animate-bounce animation-delay-1000"></div>
                <div className="absolute top-2/3 left-2/3 w-1 h-1 bg-white/50 rounded-full animate-bounce animation-delay-1500"></div>
                <div className="absolute top-1/2 right-1/3 w-1 h-1 bg-white/40 rounded-full animate-bounce animation-delay-2000"></div>
                
                {/* Wave Effects */}
                <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-primary/20 to-transparent animate-wave"></div>
                <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-secondary/10 to-transparent animate-wave animation-delay-2000"></div>
                
                {/* Rotating Rings */}
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 border border-white/10 rounded-full animate-spin-slow"></div>
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 border border-white/5 rounded-full animate-spin-slow animation-delay-1000" style={{ animationDirection: 'reverse' }}></div>
                
                {/* Grid Pattern with Animation */}
                <div className="absolute inset-0 opacity-20 animate-pulse" style={{
                    backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Ccircle cx='30' cy='30' r='1'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
                    backgroundSize: '60px 60px'
                }}></div>
                
                {/* Glowing Spots */}
                <div className="absolute top-1/4 left-1/4 w-4 h-4 bg-primary/30 rounded-full animate-ping"></div>
                <div className="absolute bottom-1/4 right-1/4 w-3 h-3 bg-secondary/30 rounded-full animate-ping animation-delay-1000"></div>
                <div className="absolute top-3/4 right-1/3 w-2 h-2 bg-green-400/30 rounded-full animate-ping animation-delay-2000"></div>
            </div>

            {/* Main Content */}
            <div className="relative z-10 flex min-h-screen">
                <div className="w-full flex items-center justify-center p-8">
                    <div className="w-full max-w-4xl">
                        {/* Register Card */}
                        <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 border border-white/20 shadow-2xl animate-fade-in-up">
                            <div className="text-center mb-8">
                                <h2 className="text-3xl font-bold text-white mb-2 animate-fade-in">Create Account</h2>
                                <p className="text-gray-300 animate-fade-in animation-delay-300">Join our catering platform</p>
                            </div>

                            <form className="space-y-6">
                                {/* Desktop Grid Layout */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    {/* First Name */}
                                    <div className="animate-fade-in-up animation-delay-500">
                                        <label className="block text-sm font-medium text-gray-300 mb-2">
                                            First Name
                                        </label>
                                        <div className="relative">
                                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                                </svg>
                                            </div>
                                            <InputFields
                                                name="firstName"
                                                label="First Name"
                                                type="text"
                                                placeholder="Enter your first name"
                                                isHideLabel="true"
                                                disabled={isLoading}
                                                handleChange={(e) => handleChange(e)}
                                                value={inputValue?.firstName}
                                                className="pl-10 w-full h-12 bg-white/10 border border-white/20 rounded-xl text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-300"
                                            />
                                        </div>
                                        {Error?.firstName && (
                                            <p className="mt-2 text-sm text-red-400 flex items-center">
                                                <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                                </svg>
                                                {Error?.firstName}
                                            </p>
                                        )}
                                    </div>

                                    {/* Last Name */}
                                    <div className="animate-fade-in-up animation-delay-600">
                                        <label className="block text-sm font-medium text-gray-300 mb-2">
                                            Last Name
                                        </label>
                                        <div className="relative">
                                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                                </svg>
                                            </div>
                                            <InputFields
                                                name="lastName"
                                                label="Last Name"
                                                type="text"
                                                placeholder="Enter your last name"
                                                isHideLabel="true"
                                                disabled={isLoading}
                                                handleChange={(e) => handleChange(e)}
                                                value={inputValue?.lastName}
                                                className="pl-10 w-full h-12 bg-white/10 border border-white/20 rounded-xl text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-300"
                                            />
                                        </div>
                                        {Error?.lastName && (
                                            <p className="mt-2 text-sm text-red-400 flex items-center">
                                                <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                                </svg>
                                                {Error?.lastName}
                                            </p>
                                        )}
                                    </div>

                                    {/* Email - Full Width */}
                                    <div className="animate-fade-in-up animation-delay-700">
                                        <label className="block text-sm font-medium text-gray-300 mb-2">
                                            Email
                                        </label>
                                        <div className="relative">
                                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                                </svg>
                                            </div>
                                            <InputFields
                                                name="email"
                                                label="Email"
                                                type="text"
                                                placeholder="Enter your email"
                                                isHideLabel="true"
                                                disabled={isLoading}
                                                handleChange={(e) => handleChange(e)}
                                                value={inputValue?.email}
                                                className="pl-10 w-full h-12 bg-white/10 border border-white/20 rounded-xl text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-300"
                                            />
                                        </div>
                                        {Error?.email && (
                                            <p className="mt-2 text-sm text-red-400 flex items-center">
                                                <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                                </svg>
                                                {Error?.email}
                                            </p>
                                        )}
                                    </div>

                                    {/* Business Email - Full Width */}
                                     {/* <div className="animate-fade-in-up animation-delay-700">
                                        <label className="block text-sm font-medium text-gray-300 mb-2">
                                          Business Email
                                        </label>
                                        <div className="relative">
                                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                                </svg>
                                            </div>
                                            <InputFields
                                                name="businessEmail"
                                                label="Business Email"
                                                type="text"
                                                placeholder="Enter your business email"
                                                isHideLabel="true"
                                                disabled={isLoading}
                                                handleChange={(e) => handleChange(e)}
                                                value={inputValue?.businessEmail}
                                                className="pl-10 w-full h-12 bg-white/10 border border-white/20 rounded-xl text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-300"
                                            />
                                        </div>
                                        {Error?.businessEmail && (
                                            <p className="mt-2 text-sm text-red-400 flex items-center">
                                                <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                                </svg>
                                                {Error?.businessEmail}
                                            </p>
                                        )}
                                    </div> */}

                                    {/* Phone - Full Width */}
                                    <div className="animate-fade-in-up animation-delay-800">
                                        <label className="block text-sm font-medium text-gray-300 mb-2">
                                            Phone
                                        </label>
                                        <div className="relative">
                                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a2 2 0 011.94 1.516l.72 3.24a2 2 0 01-.54 1.94l-1.2 1.2a16 16 0 007.07 7.07l1.2-1.2a2 2 0 011.94-.54l3.24.72A2 2 0 0121 18.72V22a2 2 0 01-2 2h-1C9.163 24 2 16.837 2 8V7a2 2 0 011-1.732z"/>
                                                </svg>
                                            </div>
                                            <InputFields
                                                name="phone"
                                                label="Phone"
                                                type="text"
                                                placeholder="Enter your phone number"
                                                isHideLabel="true"
                                                disabled={isLoading}
                                                handleChange={(e) => handleChange(e)}
                                                value={inputValue?.phone}
                                                className="pl-10 w-full h-12 bg-white/10 border border-white/20 rounded-xl text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-300"
                                            />
                                            {/* <SelectPhoneNew
                                                inputMobileData={inputMobileData}
                                                setInputValue={setInputMobileData}
                                                setErrors={setError}
                                                detectedCountry='IN'
                                                inputValueA={inputValue} setInputValueA={setInputValue}
                                            /> */}
                                        
                                        </div>
                                        {Error?.phone && (
                                            <p className="mt-2 text-sm text-red-400 flex items-center">
                                                <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                                </svg>
                                                {Error?.phone}
                                            </p>
                                        )}
                                    </div>

                                    {/* Password - Full Width */}
                                    <div className="animate-fade-in-up animation-delay-900">
                                        <label className="block text-sm font-medium text-gray-300 mb-2">
                                            Password
                                        </label>
                                        <div className="relative">
                                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                                </svg>
                                            </div>
                                            <InputFields
                                                name="password"
                                                label="Password"
                                                type="password"
                                                placeholder="Enter your password"
                                                isHideLabel="true"
                                                disabled={isLoading}
                                                handleChange={(e) => handleChange(e)}
                                                value={inputValue?.password}
                                                className="pl-10 w-full h-12 bg-white/10 border border-white/20 rounded-xl text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-300"
                                            />
                                        </div>
                                        {Error?.password && (
                                            <p className="mt-2 text-sm text-red-400 flex items-center">
                                                <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                                </svg>
                                                {Error?.password}
                                            </p>
                                        )}
                                    </div>
                                </div>

                                {/* Terms & Conditions and Privacy Policy */}
                                <div className="animate-fade-in-up animation-delay-950">
                                    <div className="flex items-start justify-center space-x-3">
                                        <input
                                            type="checkbox"
                                            id="acceptTerms"
                                            checked={acceptedTerms}
                                            onChange={(e) => setAcceptedTerms(e.target.checked)}
                                            className="mt-1 h-4 w-4 text-primary bg-white/10 border-white/20 rounded focus:ring-primary focus:ring-2 focus:ring-offset-0"
                                        />
                                        <div className="text-sm text-gray-300">
                                            <label htmlFor="acceptTerms" className="cursor-pointer">
                                                I agree to the{' '}
                                                <button
                                                    type="button"
                                                    onClick={() => setShowTerms(true)}
                                                    className="text-blue-800 hover:text-800/80 underline decoration-500 hover:decoration-blue-800 transition-all duration-300"
                                                >
                                                    Terms & Conditions
                                                </button>
                                                {' '}and{' '}
                                                <button
                                                    type="button"
                                                    onClick={() => setShowPrivacy(true)}
                                                    className="text-blue-800 hover:text-800/80 underline decoration-500 hover:decoration-blue-800 transition-all duration-300"
                                                >
                                                    Privacy Policy
                                                </button>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <button
                                    onClick={onSubmit}
                                    type="button"
                                    disabled={isLoading || !acceptedTerms}
                                    className="w-full md:w-auto md:max-w-xs mx-auto block h-12 bg-gradient-to-r from-primary to-secondary text-white font-semibold rounded-xl hover:from-secondary hover:to-primary focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-transparent transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center animate-fade-in-up animation-delay-1000 px-8"
                                >
                                    {isLoading ? (
                                        <>
                                            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>
                                            Creating account...
                                        </>
                                    ) : (
                                        <>
                                            <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
                                            </svg>
                                            Create Account
                                        </>
                                    )}
                                </button>

                                <div className="mt-4 text-center animate-fade-in-up animation-delay-1100">
                                    <span className="text-gray-300 mr-2">Already have an account?</span>
                                    <button
                                        type="button"
                                        onClick={() => navigate('/login')}
                                        className="text-white hover:text-green-300 transition-colors duration-300 font-medium underline decoration-green-400/50 hover:decoration-green-300"
                                    >
                                        Sign in
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            {/* Terms & Conditions Modal */}
            {showTerms && (
                <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
                    <div className="bg-white/10 backdrop-blur-md rounded-2xl border border-white/20 shadow-2xl max-w-2xl w-full max-h-[80vh] flex flex-col">
                        {/* Fixed Header */}
                        <div className="flex justify-between items-center p-6 pb-4 border-b border-white/10">
                            <h3 className="text-2xl font-bold text-white">Terms & Conditions</h3>
                            <button
                                onClick={() => setShowTerms(false)}
                                className="text-gray-400 hover:text-white transition-colors duration-300"
                            >
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                        
                        {/* Scrollable Content */}
                        <div className="flex-1 overflow-y-auto p-6">
                            <div className="text-white space-y-4 text-sm leading-relaxed">
                                <div className="mb-4">
                                    <p className="text-gray-200 text-center font-semibold">Effective Date: {getCurrentDate()}</p>
                                </div>
                                
                                <div>
                                    <h4 className="text-lg font-bold text-primary mb-2">1. Introduction</h4>
                                    <p className="text-gray-200">Welcome to Caterers Pro ("we," "our," "us").</p>
                                    <p className="text-gray-200">By signing up for and using our software services ("Service"), you ("User," "Customer") agree to these Terms & Conditions.</p>
                                    <p className="text-gray-200">If you do not agree, please do not use our Service.</p>
                                </div>
                                
                                <div>
                                    <h4 className="text-lg font-bold text-primary mb-2">2. Service Model</h4>
                                    <p className="text-gray-200">This software is provided on a subscription basis.</p>
                                    <p className="text-gray-200">Active subscription is required to access the Service.</p>
                                    <p className="text-gray-200">The subscription includes the right to use the application during the subscription period only.</p>
                                    <p className="text-gray-200">Direct access to the database or source code is not included in the subscription.</p>
                                </div>
                                
                                <div>
                                    <h4 className="text-lg font-bold text-primary mb-2">3. Subscription & Payment</h4>
                                    <p className="text-gray-200">Users must select and purchase a subscription plan during signup.</p>
                                    <p className="text-gray-200">Payment must be completed in full before the subscription becomes active.</p>
                                    <p className="text-gray-200">All payments are non-refundable unless otherwise stated.</p>
                                    <p className="text-gray-200">We reserve the right to suspend or terminate access if payment is not received on time.</p>
                                </div>
                                
                                <div>
                                    <h4 className="text-lg font-bold text-primary mb-2">4. Data & Database Access</h4>
                                    <p className="text-gray-200">Users can access their data through the software interface.</p>
                                    <p className="text-gray-200">Direct database access, database export, or backup is not included in the subscription.</p>
                                    <p className="text-gray-200">We maintain the database on our secure servers.</p>
                                </div>
                                
                                <div>
                                    <h4 className="text-lg font-bold text-primary mb-2">5. Intellectual Property Rights</h4>
                                    <p className="text-gray-200">All rights, titles, and interests in the software, source code, and database remain with Caterers Pro.</p>
                                    <p className="text-gray-200">The subscription grants a limited, non-exclusive, non-transferable right to use the Service during the subscription period.</p>
                                </div>
                                
                                <div>
                                    <h4 className="text-lg font-bold text-primary mb-2">6. Termination</h4>
                                    <p className="text-gray-200">The subscription will end on the expiry date unless renewed.</p>
                                    <p className="text-gray-200">Upon termination, access to the Service and associated data will be discontinued.</p>
                                    <p className="text-gray-200">We may terminate the subscription if these Terms are violated.</p>
                                </div>
                                
                                <div>
                                    <h4 className="text-lg font-bold text-primary mb-2">7. Limitation of Liability</h4>
                                    <p className="text-gray-200">We are not liable for any loss of data, business interruption, or damages resulting from the use of our Service.</p>
                                    <p className="text-gray-200">Service availability is subject to maintenance and upgrades.</p>
                                </div>
                                
                                <div>
                                    <h4 className="text-lg font-bold text-primary mb-2">8. Changes to Terms</h4>
                                    <p className="text-gray-200">We may update these Terms at any time.</p>
                                    <p className="text-gray-200">Continued use of the Service after changes means you accept the updated Terms.</p>
                                </div>
                                
                                <div>
                                    <h4 className="text-lg font-bold text-primary mb-2">9. Contact</h4>
                                    <p className="text-gray-200">For questions, contact us at:</p>
                                    <p className="text-gray-200"> Email: kevinrabadiya7952@gmail.com</p>
                                    <p className="text-gray-200">📞 Phone: +91-9662581434</p>
                                </div>
                            </div>
                        </div>
                        
                        {/* Fixed Footer */}
                        <div className="p-6 pt-4 border-t border-white/10">
                            <div className="flex justify-end">
                                <button
                                    onClick={() => setShowTerms(false)}
                                    className="px-6 py-2 bg-primary text-white font-semibold rounded-xl hover:bg-primary/80 transition-colors duration-300 border-2 border-primary hover:border-primary/80 shadow-lg"
                                >
                                    I Understand
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Privacy Policy Modal */}
            {showPrivacy && (
                <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
                    <div className="bg-white/10 backdrop-blur-md rounded-2xl border border-white/20 shadow-2xl max-w-2xl w-full max-h-[80vh] flex flex-col">
                        {/* Fixed Header */}
                        <div className="flex justify-between items-center p-6 pb-4 border-b border-white/10">
                            <h3 className="text-2xl font-bold text-white">Privacy Policy</h3>
                            <button
                                onClick={() => setShowPrivacy(false)}
                                className="text-gray-400 hover:text-white transition-colors duration-300"
                            >
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                        
                        {/* Scrollable Content */}
                        <div className="flex-1 overflow-y-auto p-6">
                            <div className="text-white space-y-4 text-sm leading-relaxed">
                                <div className="mb-4">
                                    <p className="text-gray-200 text-center font-semibold">Effective Date: {getCurrentDate()}</p>
                                </div>
                                
                                <div>
                                    <h4 className="text-lg font-bold text-primary mb-2">1. Introduction</h4>
                                    <p className="text-gray-200">Caterers Pro ("we," "us," "our") values your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your data when you use our software services ("Service").</p>
                                </div>
                                
                                <div>
                                    <h4 className="text-lg font-bold text-primary mb-2">2. Information We Collect</h4>
                                    <p className="text-gray-200"><strong>Personal Information:</strong> Name, email address, phone number, payment details, and other info you provide during signup and subscription.</p>
                                    <p className="text-gray-200"><strong>Usage Data:</strong> Information on how you use the Service, including login times, IP address, and activity logs.</p>
                                    <p className="text-gray-200"><strong>Cookies and Tracking:</strong> We may use cookies or similar technologies to improve your experience.</p>
                                </div>
                                
                                <div>
                                    <h4 className="text-lg font-bold text-primary mb-2">3. How We Use Your Information</h4>
                                    <p className="text-gray-200">• To provide and maintain the Service.</p>
                                    <p className="text-gray-200">• To process payments and manage subscriptions.</p>
                                    <p className="text-gray-200">• To communicate important updates, billing notices, and customer support.</p>
                                    <p className="text-gray-200">• To improve and personalize your experience.</p>
                                    <p className="text-gray-200">• To comply with legal obligations.</p>
                                </div>
                                
                                <div>
                                    <h4 className="text-lg font-bold text-primary mb-2">4. Data Sharing and Disclosure</h4>
                                    <p className="text-gray-200">We do not sell or rent your personal information to third parties.</p>
                                    <p className="text-gray-200">We may share data with trusted service providers (e.g., payment gateways, hosting providers) solely for Service operation.</p>
                                    <p className="text-gray-200">We may disclose information if required by law or to protect our rights.</p>
                                </div>
                                
                                <div>
                                    <h4 className="text-lg font-bold text-primary mb-2">5. Data Security</h4>
                                    <p className="text-gray-200">We implement reasonable technical and organizational measures to protect your data against unauthorized access, alteration, or destruction.</p>
                                    <p className="text-gray-200">However, no method of transmission over the internet is 100% secure.</p>
                                </div>
                                
                                <div>
                                    <h4 className="text-lg font-bold text-primary mb-2">6. Your Rights</h4>
                                    <p className="text-gray-200">You may access, update, or delete your personal information by contacting us.</p>
                                    <p className="text-gray-200">You may opt-out of promotional communications at any time.</p>
                                </div>
                                
                                <div>
                                    <h4 className="text-lg font-bold text-primary mb-2">7. Data Retention</h4>
                                    <p className="text-gray-200">We retain your data as long as necessary to provide the Service and comply with legal obligations.</p>
                                </div>
                                
                                <div>
                                    <h4 className="text-lg font-bold text-primary mb-2">8. Changes to this Policy</h4>
                                    <p className="text-gray-200">We may update this Privacy Policy from time to time.</p>
                                    <p className="text-gray-200">Continued use of the Service means you accept the updated policy.</p>
                                </div>
                                
                                <div>
                                    <h4 className="text-lg font-bold text-primary mb-2">9. Contact Us</h4>
                                    <p className="text-gray-200">For any questions about privacy, please contact:</p>
                                    <p className="text-gray-200"> Email: kevinrabadiya7952@gmail.com</p>
                                    <p className="text-gray-200">📞 Phone: +91-9662581434</p>
                                </div>
                            </div>
                        </div>
                        
                        {/* Fixed Footer */}
                        <div className="p-6 pt-4 border-t border-white/10">
                            <div className="flex justify-end">
                                <button
                                    onClick={() => setShowPrivacy(false)}
                                    className="px-6 py-2 bg-primary text-white font-semibold rounded-xl hover:bg-primary/80 transition-colors duration-300 border-2 border-primary hover:border-primary/80 shadow-lg"
                                >
                                    I Understand
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Register;
